type NameFields = {
  preferredName: string | null;
  firstName: string;
  lastName: string;
};

export function playerNames(players: NameFields[]): string[] {
  return players.map(playerName);
}

export function playerName({
  preferredName,
  firstName,
  lastName,
}: NameFields): string {
  return `${preferredName || firstName} ${lastName}`;
}
